import { render, staticRenderFns } from "./recomMenu.vue?vue&type=template&id=50686c51&scoped=true&"
import script from "./recomMenu.vue?vue&type=script&lang=js&"
export * from "./recomMenu.vue?vue&type=script&lang=js&"
import style0 from "./recomMenu.vue?vue&type=style&index=0&id=50686c51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50686c51",
  null
  
)

export default component.exports